import { closeModal } from "../../../ui/containers/Modal";
import { floodFill } from "../../../ui/helpers";
import { TextButton } from "../../../ui/input/TextButton";
import { setScene } from "../../../ui/scene";
import { ALIGN_TYPE, TextType } from "../../../ui/type/TextType";
import { ComponentF, createElement } from "../../../ui/ui";
import Colors from "../../Colors";
import { Main } from "../../scenes/main";

export const DeathModal: ComponentF<{
  title: string;
  keys: string | string[];
  onClick: () => void;
}> = (C) => {
  floodFill(C.display, C.bounds, Colors.OFF_BLACK);
  C.handlers.keypress = (key: string) => {
    if (key === "Enter") {
      return false;
    }
    return true;
  };
  return [
    createElement(
      TextType,
      { x: 1, y: 0, w: C.bounds.w - 2, h: 1 },
      { title: "DEFEAT", align: ALIGN_TYPE.center }
    ),
    createElement(
      TextType,
      { x: 1, y: 1, w: C.bounds.w - 2, h: 1 },
      {
        title: `%c{${Colors.GRAY_3}}Your spelling was not strong enough today. Regroup wizardling and maybe next time you will be victorious.`,
      }
    ),
    createElement(
      TextButton,
      { x: 1, y: C.bounds.h - 3, w: C.bounds.w - 2, h: 1 },
      {
        title: "End Game",
        keyLabel: "Esc",
        keys: ["Escape"],
        onClick: () => {
          closeModal();
          setScene(new Main());
        },
      }
    ),
  ];
};
